import { render, staticRenderFns } from "./PassShiftsModal.vue?vue&type=template&id=4cad0f56&scoped=true&lang=pug"
import script from "./PassShiftsModal.vue?vue&type=script&lang=js"
export * from "./PassShiftsModal.vue?vue&type=script&lang=js"
import style0 from "./PassShiftsModal.vue?vue&type=style&index=0&id=4cad0f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cad0f56",
  null
  
)

export default component.exports